import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import {
    Select,
    MenuItem,
    FormHelperText,
    Typography,
    Tooltip
} from '@material-ui/core'
import Slider from '../../../Slider'
import sliders from '../../../../templates/sliders'
import ItemHeader from '../ItemHeader'
import NumberField from '../../../NumberField'
import { CalculatorContext } from '../../../Context/CalculatorContext'

const QuicklinkItem = ({
    avgLength,
    value,
    downloads,
    downloadFactor,
    onChange,
    remove
}) => {
    const { tooltips } = useContext(CalculatorContext)

    return (
        <div>
            <ItemHeader
                title="Quicklink"
                tooltip={tooltips.quicklinkViews}
                remove={remove}
            />

            <Slider
                {...sliders.averageMediaLength}
                value={avgLength}
                onChange={(value) =>
                    onChange((item) => (item.avgLength = value))
                }
            />

            <Slider
                {...sliders.quicklink.views}
                value={value}
                onChange={(value) => onChange((item) => (item.value = value))}
            />
            <Tooltip title={tooltips.quicklinkDownloads}>
                <Typography color="textSecondary" gutterBottom>
                    Downloads
                </Typography>
            </Tooltip>

            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <NumberField
                    style={{ marginRight: '32px' }}
                    helperText={'Downloads'}
                    value={downloads}
                    onChange={(value) =>
                        onChange((item) => (item.downloads = value))
                    }
                />

                <div>
                    <Select
                        value={downloadFactor}
                        onChange={(e) =>
                            onChange(
                                (item) => (item.downloadFactor = e.target.value)
                            )
                        }
                    >
                        <MenuItem value={1}>Original</MenuItem>
                        <MenuItem value={0.5}>Proxy</MenuItem>
                    </Select>
                    <FormHelperText>Bitrate</FormHelperText>
                </div>
            </div>
        </div>
    )
}

QuicklinkItem.propTypes = {
    avgLength: PropTypes.number.isRequired,
    downloads: PropTypes.number.isRequired,
    downloadFactor: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired
}

export default QuicklinkItem
